import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { saveLoanApplication } from '../utils/loanService';

const fmt = n => `Ksh ${Number(n).toLocaleString()}`;

export default function Success() {
  const navigate        = useNavigate();
  const location        = useLocation();
  const { currentUser } = useAuth();
  const {
    loan, name, phone, reference, loanType, idNumber,
    paymentConfirmed, // MUST be true — set by Offers.js only after Payhero confirms payment
  } = location.state || {};

  const hasRun = useRef(false);
  const [saved, setSaved] = useState(false);

  // Guard: if payment was not confirmed by Payhero, redirect away
  // This prevents anyone bookmarking /success and claiming a free loan
  if (!loan || !paymentConfirmed) {
    navigate('/dashboard', { replace: true });
    return null;
  }

  const masked = phone ? String(phone).replace(/(\d{4})\d{4}(\d{2})$/, '$1****$2') : '07****';
  const due = new Date(Date.now() + 24 * 60 * 60 * 1000).toLocaleDateString('en-KE', {
    weekday: 'short', month: 'short', day: 'numeric', year: 'numeric',
  });

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    if (!currentUser || !paymentConfirmed) return;

    // Save loan — feePaid: true — only reaches here after Payhero confirmed payment
    saveLoanApplication({
      uid:        currentUser.uid,
      userName:   name,
      userEmail:  currentUser.email,
      userPhone:  phone,
      loanAmount: loan.amount,
      loanFee:    loan.fee,
      reference,
      loanType:   loanType || 'Personal Loan',
      idNumber:   idNumber || '—',
      dueDate:    due,
    }).then(r => setSaved(r.success));
  }, []);

  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-icon">✅</div>
        <h2 className="success-title">Payment Confirmed!</h2>
        <p className="success-sub">
          Your M-Pesa payment was received. Funds will be sent to your M-Pesa within 24 hours.
        </p>

        <div className="success-details">
          {[
            ['Applicant',   name],
            ['Loan Amount', fmt(loan.amount)],
            ['Fee Paid',    `Ksh ${loan.fee.toLocaleString()}`],
            ['Loan Type',   loanType || 'Personal Loan'],
            ['M-Pesa No.',  masked],
            ['Reference',   reference],
            ['Expected By', due],
          ].map(([k, v]) => (
            <div className="suc-row" key={k}>
              <span>{k}</span>
              <span style={{ fontSize: k === 'Reference' ? 11 : undefined, color: 'var(--primary)', fontWeight: 600 }}>{v}</span>
            </div>
          ))}
        </div>

        <div className="patience-note">
          <span style={{ fontSize: 20, flexShrink: 0 }}>🙏</span>
          <span>
            <strong>Kindly be patient.</strong> Funds arrive within 24 hours.
            Keep your M-Pesa SMS as proof of payment.
          </span>
        </div>

        <div className="info-box-blue" style={{ marginBottom: 22 }}>
          <span>📱</span>
          <span>You will receive an M-Pesa confirmation SMS once funds are disbursed.</span>
        </div>

        <button className="btn-cta" style={{ marginBottom: 10 }} onClick={() => navigate('/history')}>
          📜 View My Loan Status
        </button>
        <button className="btn-secondary" style={{ marginBottom: 10 }} onClick={() => navigate('/dashboard')}>
          💰 Apply for Another Loan
        </button>

        <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--text-light)' }}>
          © 2026 Lend Pesa · Licensed by CBK
        </p>
      </div>
    </div>
  );
}
